import React from "react";
import _ from "lodash";

import AppColors from "../../constants/AppColors";
import Glyphicon from "../base/Glyphicon";
import LoadingSpinner from "../LoadingSpinner.jsx";

function DataAvailabilityView(props) {
  const available = props.available;
  const error = props.error;
  let view = null;

  let style = {
    minHeight: 100,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  let viewStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  _.merge(style, _.get(props, "style", {}));

  if (available) {
    return props.children;
  } else {
    if (error) {
      view = (
        <div style={viewStyle}>
          <Glyphicon glyph="warning_sign" style={{ fontSize: 24, color: AppColors.WARNING }} />
          <div style={{ paddingTop: 4 }}>{props.errorMessage}</div>
        </div>
      );
    } else {
      view = (
        <div style={viewStyle}>
          <LoadingSpinner />
          <div style={{ paddingTop: 4 }}>{props.loadingMessage}</div>
        </div>
      );
    }
  }

  return <div style={style}>{view}</div>;
}

DataAvailabilityView.defaultProps = {
  errorMessage: "Unable To Load",
  loadingMessage: "Loading",
};

export default DataAvailabilityView;
